"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = require("styled-components");

var _Theme = require("../../../Theme/Theme.variables");

var _IconBase = require("./IconBase");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

var NotRenting =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(NotRenting, _PureComponent);

  function NotRenting() {
    _classCallCheck(this, NotRenting);

    return _possibleConstructorReturn(this, _getPrototypeOf(NotRenting).apply(this, arguments));
  }

  _createClass(NotRenting, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          style = _this$props.style,
          height = _this$props.height,
          width = _this$props.width;
      return _react.default.createElement(_IconBase.IconBase, _extends({
        width: width,
        height: height,
        className: className,
        style: style,
        viewBox: "0 0 38 38",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg"
      }, this.props), _react.default.createElement("title", null, "Not Renting Icon"), _react.default.createElement("g", {
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd"
      }, _react.default.createElement("g", {
        transform: "translate(-203.000000, -680.000000)"
      }, _react.default.createElement("g", {
        transform: "translate(203.000000, 680.000000)"
      }, _react.default.createElement("polygon", {
        fill: "#CCCCCC",
        points: "26.7324 28.6602 30.1034 28.2202 27.2464 10.0112 21.7484 7.5932 19.8094 15.9162 19.5704 10.9162 19.2934 9.4102 19.8424 8.0552 18.1214 8.0552 18.7074 9.4102 18.4084 10.9222 18.1334 15.6702 16.2524 7.5932 10.7534 10.0112 7.8964 28.2202 11.2674 28.6602 13.2824 15.9832 13.5754 21.4422 12.9184 28.8432 19.0004 28.8432 25.0824 28.8432 24.4244 21.4422 24.7174 15.9832"
      }), _react.default.createElement("path", {
        d: "M19,37 C14.217,37 9.875,35.112 6.648,32.058 L32.058,6.648 C35.112,9.875 37,14.217 37,19 C37,28.925 28.925,37 19,37 M1,19 C1,9.075 9.075,1 19,1 C23.782,1 28.124,2.887 31.351,5.941 L5.941,31.351 C2.888,28.125 1,23.783 1,19 M19,0 C8.523,0 0,8.523 0,19 C0,29.477 8.523,38 19,38 C29.477,38 38,29.477 38,19 C38,8.523 29.477,0 19,0",
        fill: "#888888"
      })))));
    }
  }]);

  return NotRenting;
}(_react.PureComponent);

NotRenting.displayName = 'NotRenting'; // Prop Types

NotRenting.propTypes = {
  className: _propTypes.default.string,
  style: _propTypes.default.object,
  width: _propTypes.default.string,
  height: _propTypes.default.string,
  color: _propTypes.default.string
};
NotRenting.defaultProps = {
  className: '',
  style: {},
  height: '38',
  width: '38'
};

var _default = (0, _styledComponents.withTheme)(NotRenting);

exports.default = _default;